import mainApi from "./mainApi";

export function rewardsApi() {
    return {
        getRewards: async function(username) {
            return mainApi.get(`/rewards/${username}`);
        }
    }
}